import gql from "graphql-tag"

import linkedCard from "../fragments/LinkedCard"

const LinkedCardList = gql`
  query PerksGoLinkedCardList($userId: ID!) {
    linkedCards(userId: $userId) {
      results {
        ...card
      }
    }
  }
  ${linkedCard}
`

export default LinkedCardList
